import { Notification, Button } from "react-bulma-components/full";
import Linkify from "react-linkify";
import styled from "styled-components";
import { HiMiniXMark } from "react-icons/hi2";
import { gravityMessage } from "../../utils/InfoBarUtils";

const InfoBarContainer = styled.div`
  position: relative;
  z-index: 10;
  width: 100%;

  .notification {
    border-radius: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1.25rem 2.5rem;
  }

  svg {
    position: absolute;
    top: 5px;
    right: 5px;
    cursor: pointer;
    transition: transform 0.2s ease-in-out;
    font-size: 1.5em;
    &:hover {
      transform: scale(1.25);
    }
  }
`;

const StyledTextWithLink = styled.div``;

export default function InfoBar(props) {
  const style = gravityMessage[props.type] || gravityMessage["info"];

  return (
    <InfoBarContainer>
      <Notification style={style}>
        <StyledTextWithLink>
          <Linkify
            componentDecorator={(decoratedHref, decoratedText, key) => (
              <a
                target="blank"
                rel="noopener noreferrer"
                href={decoratedHref}
                key={key}
              >
                {decoratedText}
              </a>
            )}
          >
            {props.content}
          </Linkify>
        </StyledTextWithLink>
      </Notification>
      <HiMiniXMark onClick={props.handleCloseInfoBar} />
    </InfoBarContainer>
  );
}
